<template>
  <div>
    <Header />
    <!-- Login / Register -->
    <v-dialog
      v-model="register"
      fullscreen
      persistent
      transition="fade-transition"
    >
      <v-card class="d-flex justify-center flex-column align-center">
        <v-card-title class="text-center justify-center mb-2">
          <h3 class="sign-up__title">
            Faça seu cadastro!
          </h3>
        </v-card-title>
        <v-card-subtitle class="text-center">
          <h6 class="sign-up__subtitle mt-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore
          </h6>
        </v-card-subtitle>
        <v-card-text class="d-flex justify-center">
          <v-card
            outlined
            elevation="0"
            max-width="620"
            class="px-6 py-4"
          >
            <v-card-text>
              <v-form
                ref="formRegister"
                v-model="registerFormValid"
                class="form"
                lazy-validation
              >
                <v-row>
                  <v-col cols="12">
                    <h6 class="form__title">
                      Informe os dados abaixo
                    </h6>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.name"
                      label="Nome*"
                      required
                      outlined
                      hide-details
                      :rules="[() => !!registerForm.name]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.cpf_number"
                      v-mask="'###.###.###-##'"
                      label="CPF*"
                      required
                      outlined
                      hide-details
                      :rules="[() => !!registerForm.cpf_number,
                               () => registerForm.cpf_number.length === 14]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.id_number"
                      v-mask="'##.###.###-#'"
                      label="RG*"
                      required
                      outlined
                      hide-details
                      :rules="[() => !!registerForm.id_number,
                               () => registerForm.id_number.length === 12]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.phone_number"
                      v-mask="'(##)#####-####'"
                      label="Celular*"
                      required
                      outlined
                      hide-details
                      :rules="[
                        () => !!registerForm.phone_number,
                        () => registerForm.phone_number.length === 14,
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.email"
                      label="Email*"
                      :rules="emailRules"
                      required
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.password"
                      label="Senha*"
                      required
                      outlined
                      hide-details
                      type="password"
                      :rules="[() => !!registerForm.password]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="registerForm.password_confirmation"
                      label="Confirme a sua senha*"
                      required
                      outlined
                      hide-details
                      type="password"
                      :rules="[
                        () =>
                          !!registerForm.password_confirmation &&
                          registerForm.password_confirmation === registerForm.password,
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span class="error">{{ registerWarningMessage }}</span>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions class="align-center justify-center">
              <Button
                background-color="#ffffff"
                border-color="#ee396c"
                font-color="#ee396c"
                @click="register = false"
              >
                Cancelar
              </Button>
              <Button
                class="ml-3"
                @click="handleRegister"
              >
                Realizar cadastro
              </Button>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="login"
      persistent
      fullscreen
      transition="fade-transition"
    >
      <v-card class="d-flex justify-center flex-column align-center">
        <v-card-title class="text-center justify-center mb-2">
          <h3 class="sign-up__title">
            Acesse sua conta
          </h3>
        </v-card-title>
        <v-card-subtitle class="text-center">
          <h6 class="sign-up__subtitle">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore
          </h6>
        </v-card-subtitle>
        <v-card-text class="d-flex justify-center">
          <v-card
            outlined
            elevation="0"
            max-width="620"
            class="px-6 py-4"
          >
            <v-card-text>
              <v-form
                ref="formLogin"
                v-model="loginFormValid"
                lazy-validation
              >
                <v-row>
                  <v-col cols="12">
                    <h6 class="form__title">
                      Informe os dados abaixo
                    </h6>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="loginForm.email"
                      :rules="emailRules"
                      label="Email*"
                      required
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="loginForm.password"
                      label="Senha*"
                      required
                      outlined
                      hide-details
                      type="password"
                      :rules="[() => !!loginForm.password || 'A senha é obrigatória.']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span class="error">{{ loginWarningMessage }}</span>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions class="align-center justify-center">
              <Button
                elevation="0"
                @click="handleLogin"
              >
                Acessar Conta
              </Button>
              <Button
                background-color="#ffffff"
                border-color="#ee396c"
                font-color="#ee396c"
                class="ml-3"
                @click="login = false"
              >
                Cancelar
              </Button>
            </v-card-actions>
            <v-card-actions class="align-center justify-center">
              <v-btn
                text
                x-small
              >
                Esqueci minha senha
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div
      class="page"
      style="padding-top: 40px"
    >
      <Notification />
      <v-main class="main-view">
        <v-container
          class="pa-0"
          fluid
        >
          <TheBreadcrumb />
          <router-view></router-view>
          <Newsletter></Newsletter>
          <Footer></Footer>
        </v-container>
      </v-main>
    </div>
  </div>
</template>
<script>
import Notification from '@/components/Notification';
import Header from '@/components/Header/Header.vue';
// import TheNavigationDrawer from '@/components/TheNavigationDrawer';
import TheBreadcrumb from '@/components/TheBreadcrumb';
// import UserMenu from '@/components/UserMenu';
import IdleService from '@/services/IdleService';
import Footer from '@/components/Footer/Footer.vue';
import Button from '@/components/Button/Button.vue';
import Newsletter from '@/components/Newsletter/Newsletter.vue';
import RegisterMixin from '@/mixins/RegisterMixin';
import AuthService from '@/services/AuthService';

export default {
  name: 'Backoffice',
  components: {
    Newsletter,
    Footer,
    Header,
    // TheNavigationDrawer,
    TheBreadcrumb,
    // UserMenu,
    Notification,
    Button,
  },
  mixins: [RegisterMixin],
  data() {
    return {
      loginFormValid: true,
      registerFormValid: true,
      loginWarningMessage: '',
      registerWarningMessage: '',
      emailRules: [
        (v) => !!v,
        (v) => /.+@.+\..+/.test(v),
      ],
      loginForm: {
        email: '',
        password: '',
      },
      registerForm: {
        name: '',
        cpf_number: '',
        id_number: '',
        phone_number: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    },
    userData() {
      return this.$store.state.Data.User.profile;
    },
  },
  created() {
    // UserService.retriverProfileInfo();
    this.$bus.on(this.$events.GET_PARTNER, () => {
      // UserService.retriverProfileInfo();
    });
  },
  beforeCreate() {
    IdleService.init();
  },
  beforeDestroy() {
    IdleService.destroy();
  },
  methods: {
    logOut() {
      this.$router.push({ name: this.$consts.ROUTES.AUTH_LOGIN.NAME });
    },

    validateLoginForm() {
      return this.$refs.formLogin.validate();
    },

    validateRegisterForm() {
      return this.$refs.formRegister.validate();
    },

    handleLogin() {
      this.loginWarningMessage = '';
      if (this.validateLoginForm()) {
        AuthService.login(this.loginForm.email, this.loginForm.password, this.loginForm.password)
          .then(() => {
            // eslint-disable-next-line prefer-rest-params
            this.login = false;
          })
          .catch((error) => {
            this.loginWarningMessage = 'Erro ao efetuar o login';
             throw error;
          });
      }
    },

    handleRegister() {
      this.registerWarningMessage = '';
      if (this.validateRegisterForm()) {
        AuthService.register(this.registerForm)
          .then(() => {
            // eslint-disable-next-line prefer-rest-params
            this.register = false;
            this.login = true;
          })
          .catch((error) => {
            this.registerWarningMessage = 'Erro ao efetuar o cadastro';
            throw error;
          });
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/static/css/Variables.scss';
.sign-up {
  &__title {
    font-size: 48px;
    line-height: 72px;
    text-align: center;
    letter-spacing: -0.015em;
    color: #000000;
    font-weight: 400;

    @media (max-width: $md) {
      font-size: 26px;
      line-height: 30px;
    }
  }
  &__subtitle {
    font-size: 26px;
    line-height: 50px;
    text-align: center;
    letter-spacing: -0.015em;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 400;

    @media (max-width: $md) {
      font-size: 16px;
      line-height: 20px;
    }
  }
}

.form {
  .error{
    font-size: 16px;
    color: red;
    font-weight: 600;
  }
  &__title {
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -0.015em;
    color: #000000;

    @media (max-width: $md) {
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
